import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useSelector, useDispatch} from "react-redux";
import {
    Link,
    useHistory
} from "react-router-dom";
import {getAllDeparturesReasons} from "../../../redux/departures";

/** @module  Pages/departure_reasons/reasons */

const Reasons = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const reasons = useSelector((state) => state.departures_module._get_all_departures_reasons);
    const {token} = useSelector((state) => state.users_module.login.data) || null;
    const [data, setData] = useState([]);
    const [permisos, setPermisos] = useState([]);

    useEffect(() => {
        dispatch(getAllDeparturesReasons(token));
    }, [token, dispatch]);

    useEffect(() => {
        if (reasons && reasons.data && reasons.data.datos) {
            setData(reasons.data.datos);
        }
    }, [reasons]);

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);

        }
    }, [props]);

    const [actions, setActions] = useState([]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_reasons').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "primary",
                    onClick: (item) => {
                        history.push({pathname: `/razones/editar/${item.id}`});
                    },
                })
            }
        }
        setActions(act);


    }, [permisos, history]);

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Razones"
                            items={[{label: "Razones", link: "/razones"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_reasons').length > 0 ? <Link
                                        to="/razones/crear"
                                        className="btn btn-success"
                                    >
                                        Crear
                                    </Link> : null
                                }

                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "descripcion",
                                                label: "Descripcion",
                                                type: "text",
                                            },
                                            {
                                                name: "tipo",
                                                label: "Tipo",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                            {
                                                name: "salida_sin_aprobacion",
                                                label: "Salida sin aprobación",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Reasons;
